import {AbstractControl} from '@angular/forms';
import {Directive} from '@angular/core';
import {Input} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {OnChanges} from '@angular/core';
import {SimpleChanges} from '@angular/core';
import {Validator} from '@angular/forms';
import {ValidatorFn} from '@angular/forms';
import {Validators} from '@angular/forms';

function isValidPhoneFormat(phone: string): boolean {
    return /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/.test(phone);
}

export function phoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const { value } = control;
        if (value) {
            return isValidPhoneFormat(value) ? null : { 'phone': { value } };
        }
    };
}

@Directive({
    selector: '[phoneValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true }]
})
export class PhoneValidatorDirective implements Validator, OnChanges {

    private _valFn = Validators.nullValidator;

    @Input()
    phoneValidator: string;

    ngOnChanges(changes: SimpleChanges): void {
        this._valFn = changes['phoneValidator'] ? phoneValidator() : Validators.nullValidator;
    }

    validate(control: AbstractControl): { [key: string]: any } {
        return this._valFn(control);
    }

}
